const { origin } = window.location;

export const routes = {
  main: `${origin}/`,
  policyDetails: (id: string) => `${origin}/policy/${id}`,
};
